import { z } from 'zod';
import { IsoTimestamp } from './primitives.js';
import { ActorType } from './enums.js';

/** Versioned domain-event envelope (§29). Consumers assume at-least-once delivery. */
export const DomainEventType = z.enum([
  'gig.created',
  'gig.published',
  'gig.started',
  'gig.intermission_started',
  'gig.resumed',
  'gig.ended',
  'gig.live_state_changed',
  'public_snapshot.requested',
  'public_snapshot.generated',
  'interaction.created',
  'interaction.moderated',
  'interaction.status_changed',
  'improv_brief.derived',
  'notification.requested',
  'notification.delivered',
  'notification.failed',
  'tip.checkout_created',
  'tip.succeeded',
  'tip.failed',
  'tip.refunded',
  'tip.disputed',
  'payment_connection.updated',
  'analytics.event_recorded',
  'audit.event_created',
]);
export type DomainEventType = z.infer<typeof DomainEventType>;

export const DomainEventEnvelope = z.object({
  eventId: z.string(),
  type: DomainEventType,
  schemaVersion: z.number().int().positive(),
  occurredAt: IsoTimestamp,
  workspaceId: z.string().nullable(),
  artistId: z.string().nullable(),
  gigId: z.string().nullable(),
  requestId: z.string().nullable(),
  correlationId: z.string().nullable(),
  actorType: ActorType,
  actorId: z.string().nullable(),
  /** Safe payload — never includes secrets or raw audience content that logs would capture. */
  payload: z.record(z.string(), z.unknown()),
});
export type DomainEventEnvelope = z.infer<typeof DomainEventEnvelope>;
